import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ClassService } from 'src/app/providers/class/class.service';
import { DataService } from 'src/app/providers/data.service';
import { ExamService } from 'src/app/providers/exam/exam.service';
import { QuestionService } from 'src/app/providers/question/question.service';
import { StudentService } from 'src/app/providers/student/student.service';
import { SubjectService } from 'src/app/providers/subject/subject.service';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DataService]
})
export class DashboardComponent implements OnInit {

  subjects = [];
  classes = [];
  students = [];
  questions = [];
  exams = [];

  // paginator: MatPaginator;

  constructor(public dataService: DataService,
    private subjectService: SubjectService,
    private classService: ClassService,
    private studentService: StudentService,
    private questionService: QuestionService,
    private examService: ExamService) { }

  ngOnInit() {
    //subject list
    this.getsubjectData();
    this.getclassData();
    this.getstudentData();
    this.getquestionData();
    this.getexamData();
  }

  getsubjectData() {
    this.subjectService.viewSubject()
      .subscribe(
        (data: any) => {
          this.subjects = data;
        });
  }

  getclassData() {
    this.classService.viewClass()
      .subscribe(
        (data: any) => {
          this.classes = data;
        });
  }

  getstudentData() {
    this.studentService.viewStudent()
      .subscribe(
        (data: any) => {
          this.students = data;
        });
  }

  getquestionData() {
    this.questionService.viewQuestion()
      .subscribe(
        (data: any) => {
          this.questions = data;
        });
  }
  getexamData() {
    this.examService.viewExam()
      .subscribe(
        (data: any) => {
          this.exams = data;
        });
  }

}
